{
  "dropzoneLabel": "Zona di rilascio",
  "selectPlaceholder": "Seleziona un elemento",
  "tableResizer": "Ridimensionamento",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
